import {Divider, Tab, Tabs, useTheme} from "@mui/material";
import {useState} from "react";

const DetailTabsSection = ({tabs = [], defaultTab = 0}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const theme = useTheme();

  if (!tabs.length) {
    return null;
  }

  return (
    <>
      <Divider sx={{mb: 2, borderColor: theme.palette.text.divider}} />
      <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} sx={{mb: 2}}>
        {tabs.map((tab, index) => (
          <Tab key={tab.key || `${tab.label}-${index}`} label={tab.label} />
        ))}
      </Tabs>
      {tabs[activeTab]?.content || null}
    </>
  );
};

export default DetailTabsSection;
